import { toutesCommunes } from '@/data/communes';

// Source unique de vérité : uniquement les communes qui ONT une page générée.
// Chaque entrée expose son urlPath réel (jamais de lien construit à la main).
export const communes = toutesCommunes.map((c) => ({
  name: c.nom,
  slug: c.slug,
  urlPath: c.urlPath,
}));
